export default "__VITE_ASSET__2d234bc2__"